<template>
  <div class="t-app__container">
    <div class="h-section">
      <form-stepper-heading :step="step" :nbSteps="4" :stepTitle="$t(currentStepTitle)" :formTitle="$t('create-gathering-form-title')" />
    </div>

    <div v-if="gathering" class="h-section h-section--large h-section--no-margin-top">
      <edit-summary v-if="step === 1" v-model="gathering" :canEditName="isAdmin" @saveAndBack="back" @saveAndQuit="quit" @saveAndContinue="next" @previewGathering="previewGathering" />
      <edit-logistic v-if="step === 2" v-model="gathering" @saveAndBack="back" @saveAndQuit="quit" @saveAndContinue="next" @previewGathering="previewGathering" />
      <edit-organizer v-if="step === 3" v-model="gathering" @saveAndBack="back" @saveAndQuit="quit" @saveAndContinue="next" @previewGathering="previewGathering" />
      <edit-signature v-if="step === 4" v-model="gathering" @saveAndBack="back" @saveAndQuit="quit" @previewGathering="previewGathering" @submitGathering="submitGathering" />
    </div>

    <div class="t-app__confetti t-app__confetti--01"></div>
    <div class="t-app__dot t-app__dot--large"></div>
    <div class="t-app__confetti t-app__confetti--02"></div>
    <div class="t-app__confetti t-app__confetti--03"></div>
    <div class="t-app__confetti t-app__confetti--04"></div>
    <div class="t-app__dot t-app__dot--medium"></div>
    <div class="t-app__confetti t-app__confetti--05"></div>
  </div>
</template>

<script>
import FormStepperHeading from '@/components/ui/form-stepper-heading'
import EditSummary from '@/components/pages/gathering/edit-steps/edit-summary'
import EditLogistic from '@/components/pages/gathering/edit-steps/edit-logistic'
import EditOrganizer from '@/components/pages/gathering/edit-steps/edit-organizer'
import EditSignature from '@/components/pages/gathering/edit-steps/edit-signature'

import router from '@/router'
import { URL_EDIT_GATHERING, URL_USER_ORGANIZE_DASHBOARD, URL_ADMIN_GATHERING_DASHBOARD, URL_GATHERING_SUBMITTED } from '@/consts/urls'
import { USER_TYPE_ADMIN } from '@/consts/enums'

import AuthentificationService from '@/services/authentification'
import GatheringService from '@/services/gathering'
import LoaderService from '@/services/loader'

export default {
  components: {
    FormStepperHeading,
    EditSummary,
    EditLogistic,
    EditOrganizer,
    EditSignature
  },
  data() {
    return {
      step: this.$router.currentRoute.query.step ? parseInt(this.$router.currentRoute.query.step) : 1,
      gathering: null,
      markAsFullActions: [
        { key: 'markAsFullGathering_yes', label: this.$t('popup_confirm_label'), click: this.markAsFull },
        { key: 'markAsFullGathering_no', label: this.$t('popup_dismiss_label'), click: this.hideMarkAsFullPanel }
      ]
    }
  },
  async beforeRouteEnter(to, from, next) {
    LoaderService.showLoader()

    const gathering = await GatheringService.getGatheringById(to.params.id)

    next(vm => {
      vm.gathering = gathering
      LoaderService.hideLoader()
    })
  },
  async beforeRouteUpdate(to, from, next) {
    this.step = to.query.step ? parseInt(to.query.step) : 1
    next()
  },
  computed: {
    isAdmin: function() {
      return AuthentificationService.getUserType() === USER_TYPE_ADMIN
    },
    isAuthorized: function() {
      return this.initialGatheringValue.IsPublish
    },
    isSubmitted: function() {
      return this.initialGatheringValue.IsSubmitted
    },
    currentStepTitle: function() {
      switch (this.step) {
        case 1:
          return 'gathering-form-step-1-title'
        case 2:
          return 'gathering-form-step-2-title'
        case 3:
          return 'gathering-form-step-3-title'
        case 4:
          return 'gathering-form-step-signature-title'
      }
      return ''
    }
  },
  methods: {
    scrollToTop: function() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0
    },
    back: function() {
      this.scrollToTop()
      this.$router.back()
    },
    quit: function() {
      if (AuthentificationService.getUserType() === USER_TYPE_ADMIN) {
        router.push({ name: URL_ADMIN_GATHERING_DASHBOARD })
      } else {
        router.push({ name: URL_USER_ORGANIZE_DASHBOARD })
      }
    },
    next: function() {
      this.step += 1
      this.scrollToTop()
      this.$router.push({ name: URL_EDIT_GATHERING, params: { id: this.gathering.Id }, query: { step: this.step } })
    },
    previewGathering: function() {
      window.location.href = this.$t('App.Settings.Preview.Url') + this.$slugiffy(this.gathering.Name + '-' + this.gathering.Id) + '?isPreview=true'
    },
    submitGathering: async function() {
      if (!this.isAdmin) {
        router.push({ name: URL_GATHERING_SUBMITTED })
      }
    }
  },
  watch: {
    isFull: function(val) {
      if (val && val !== this.initialGatheringValue.IsFull) {
        this.showMarkAsFull()
      }
    }
  }
}
</script>
